import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import GoogleMaterialIcon from '@/components/icons/google-material-icon/google-material-icon';
import { Topic } from '@/models/proficiency/domain-topic/topic';

@Component({
    name: 'domain-card',
    components: {
        'material-icon': GoogleMaterialIcon,
    },
})

export default class DomainCard extends Vue {

    // ------------------------------------------------------
    // Properties
    @Prop()
    private domainList: any;

    // ----------------------------------------------------------------------------------
    // Actions
    private onSelectDomain(domain: any) {
        this.domainList.map((domainItem: any) => {
            if (domain.domainCode !== domainItem.domainCode) {
                this.$set(domainItem, 'isActive', false);
            }
        });
        const isActive = !domain.isActive;
        this.$set(domain, 'topic', isActive);
        this.$emit('onSelectDomain', isActive ? domain : null);

    }

    // private onSelectTopic(topic: Topic) {
    //     console.log('topic', topic)
    // }

    private onSelectCompetency(competency: any) {
        this.$emit('onSelectCompetency', competency);
    }

}
